import { nnbsp } from 'console/utils/chars';
import { prettyFloat } from 'webui/utils/number';
import { GraphAxis } from './axis-base';
import { owa_axes } from 'console/tabs/graphs/components/graph/utils/owa-axes';
const format_price = (price) => {
    let price_str = price.toString();
    let pos = price_str.length - 3;
    while (pos > 0) {
        price_str = price_str.substr(0, pos) + nnbsp + price_str.substr(pos);
        pos -= 3;
    }
    return price_str;
};
class TemperatureAxis extends GraphAxis {
    options = () => ({
        minTickSize: 1,
        tickFormatter(val) {
            return prettyFloat(val, 1);
        },
    });
    unit = () => '°C';
    format_value = (val) => val.toFixed(1);
    format_value_with_unit = (val) => `${this.format_value(val)}°`;
}
const instances = {
    empty: new (class extends GraphAxis {
        options = () => ({
            show: false,
            reserveSpace: true,
        });
    })(),
    temperature: new TemperatureAxis(),
    pressure: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'бар';
        format_value = (val) => val.toFixed(2);
    })(),
    count: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            minTickSize: 1,
        });
        unit = () => 'шт';
        format_value = (val) => val.toFixed(0);
    })(),
    percent: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 1,
        });
        unit = () => '%';
        unit_separator = () => '';
        format_value = (val) => val.toFixed(0);
    })(),
    'percent-0': new (class extends GraphAxis {
        options = () => ({
            min: 0,
            minTickSize: 1,
        });
        unit = () => '%';
        unit_separator = () => '';
        format_value = (val) => val.toFixed(0);
    })(),
    'percent-0-100': new (class extends GraphAxis {
        options = () => ({
            min: 0,
            max: 100,
            minTickSize: 1,
        });
        unit = () => '%';
        unit_separator = () => '';
        format_value = (val) => val.toFixed(0);
    })(),
    flow: new (class extends GraphAxis {
        unit = () => 'л/мин';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    flowPerHour: new (class extends GraphAxis {
        unit = () => 'л/ч';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    balance: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 1,
        });
        unit = () => '₽';
        format_value = (val) => format_price(val);
    })(),
    speed: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            minTickSize: 1,
        });
        unit = () => 'км/ч';
        format_value = (val) => val.toFixed(0);
    })(),
    meters: new (class extends GraphAxis {
        unit = () => 'м';
        format_value = (val) => val.toFixed(0);
    })(),
    acceleration: new (class extends GraphAxis {
        unit = () => 'м/с²';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    voltage: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'вольт';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    resistance: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'кОм';
        format_value = (val) => prettyFloat(val / 1000, 1);
    })(),
    resistanceOM: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'Ом';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    onoff: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            max: 1,
            minTickSize: 1,
        });
        unit = () => '';
        format_value = (val) => (val > 0 ? 'вкл' : 'выкл');
    })(),
    pressed: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            max: 1,
            minTickSize: 1,
        });
        unit = () => '';
        format_value = (val) => (val > 0 ? 'нажата' : 'не нажата');
    })(),
    fuel_per_hour: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'л/ч';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    hour: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'ч';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    km: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'км';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    liter: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'л';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    dbm: new (class extends GraphAxis {
        options = () => ({
            min: -120,
            minTickSize: 1,
            max: 0,
        });
        unit = () => 'дБм';
        format_value = (val) => val.toFixed(0);
    })(),
    autoscan_turn: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'об/мин';
        format_value = (val) => val.toFixed(0);
    })(),
    autoscan_fuel: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'л';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    autoscan_spent: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => 'л/мин';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    kg: new (class extends GraphAxis {
        options() {
            return { minTickSize: 0.1 };
        }
        unit = () => 'кг';
        format_value = (val) => val.toFixed(0);
    })(),
    autoscan_hdop: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            max: 10,
        });
    })(),
    autoscan_gsm: new (class extends GraphAxis {
        options = () => ({
            min: 0,
            max: 31,
        });
    })(),
    angle: new (class extends GraphAxis {
        options = () => ({
            min: 0,
        });
        unit = () => '°';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    herz: new (class extends GraphAxis {
        unit = () => 'Гц';
    })(),
    amper: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'А';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    stream: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'м³/ч';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    ppm: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'ppm';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    reactive_power: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'ВАР';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    active_power: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'Вт';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    full_power: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'ВА';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    energy: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'кВт•ч';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    milliamper: new (class extends GraphAxis {
        options = () => ({
            minTickSize: 0.1,
        });
        unit = () => 'мА';
        format_value = (val) => prettyFloat(val, 1);
    })(),
    without_unit: new (class extends GraphAxis {
        unit = () => '';
    })(),
    ...owa_axes,
};
export default (key) => instances[key];
